(function () {
    /**
     * Initialize page transition exclusions for cross-document navigations.
     * Uses lightweight intent tracking to decide when to skip transitions.
     */
    const initializePageTransitionsGuard = function () {
        // Progressive enhancement: no-op when pageswap/view transitions are unavailable.
        if (typeof window === 'undefined' || typeof window.addEventListener !== 'function' || !('onpageswap' in window)) {
            return;
        }

        const formSubmitIntentWindowMs = 4000;

        let lastLinkIntent = null;
        let lastFormSubmitAt = 0;

        const getUrl = function (value) {
            if (typeof value !== 'string' || value.length === 0) {
                return null;
            }

            try {
                return new URL(value, window.location.href);
            } catch {
                return null;
            }
        };

        const isUmbracoRoute = function (url) {
            if (!(url instanceof URL)) {
                return false;
            }

            return /^\/umbraco(?:\/|$)/i.test(url.pathname || '');
        };

        const shouldSkipForLinkIntent = function (targetUrl) {
            if (!lastLinkIntent) {
                return false;
            }

            // Skip when the link points to another origin.
            if (lastLinkIntent.isExternal) {
                return true;
            }

            // Skip for links that intentionally open in a new tab/window.
            if (lastLinkIntent.opensNewTab) {
                return true;
            }

            // Skip for download links to avoid animating file transfers.
            if (lastLinkIntent.isDownload) {
                return true;
            }

            // Skip when modifier keys (ctrl/cmd/shift) are used for alternate navigation behavior.
            if (lastLinkIntent.hasModifierKey) {
                return true;
            }

            // Skip hash-only same-page anchor jumps.
            if (lastLinkIntent.isHashOnly) {
                return true;
            }

            // Defensive fallback: if the link target itself is an Umbraco route, skip.
            if (isUmbracoRoute(targetUrl)) {
                return true;
            }

            return false;
        };

        document.addEventListener('click', function (event) {
            const target = event && event.target;

            if (!(target instanceof Element)) {
                return;
            }

            const anchor = target.closest('a');

            if (!(anchor instanceof HTMLAnchorElement)) {
                return;
            }

            const href = anchor.getAttribute('href') || '';
            const hrefTrimmed = href.trim();

            if (hrefTrimmed.length === 0 || hrefTrimmed.startsWith('javascript:')) {
                lastLinkIntent = null;
                return;
            }

            const resolvedUrl = getUrl(anchor.href || hrefTrimmed);
            const currentUrl = getUrl(window.location.href);

            if (!(resolvedUrl instanceof URL) || !(currentUrl instanceof URL)) {
                lastLinkIntent = null;
                return;
            }

            const hasModifierKey = !!(event.ctrlKey || event.metaKey || event.shiftKey);
            const isHashOnly = resolvedUrl.origin === currentUrl.origin &&
                resolvedUrl.pathname === currentUrl.pathname &&
                resolvedUrl.search === currentUrl.search &&
                resolvedUrl.hash.length > 0;

            const targetAttr = (anchor.getAttribute('target') || '').toLowerCase();
            const opensNewTab = targetAttr === '_blank';

            lastLinkIntent = {
                hasModifierKey: hasModifierKey,
                isDownload: anchor.hasAttribute('download'),
                isExternal: resolvedUrl.origin !== currentUrl.origin,
                isHashOnly: isHashOnly,
                opensNewTab: opensNewTab,
                url: resolvedUrl
            };
        }, true);

        document.addEventListener('submit', function () {
            // Skip view transitions after form submits so post/redirect flows stay explicit.
            lastFormSubmitAt = Date.now();
        }, true);

        window.addEventListener('pageswap', function (event) {
            const transition = event && event.viewTransition;

            if (!transition || typeof transition.skipTransition !== 'function') {
                return;
            }

            const activation = event.activation || null;
            const toUrl = getUrl(activation && activation.entry ? activation.entry.url : '');

            // Never transition Umbraco backoffice/admin routes.
            if (isUmbracoRoute(toUrl)) {
                transition.skipTransition();
                return;
            }

            // Exclude navigations triggered by form submission intent.
            if (Date.now() - lastFormSubmitAt <= formSubmitIntentWindowMs) {
                transition.skipTransition();
                return;
            }

            // Exclude based on captured link intent (external/new tab/download/modifier/hash-only).
            if (shouldSkipForLinkIntent(toUrl)) {
                transition.skipTransition();
            }

            lastLinkIntent = null;
        });
    };

    initializePageTransitionsGuard();
})();
